import React, { useState, useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import axios from 'axios';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const PhotoSlider = ({ cardId, fontP }) => {
  const [photos, setPhotos] = useState([]);
  // const [loading, setLoading] = useState(true);
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: '-20% 0px -20% 0px' }); // fine-tune trigger area

  useEffect(() => {
    const fetchPhotos = async () => {
      if (!cardId) return;

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/gallery/${cardId}`);
        setPhotos(response.data);
      } catch (error) {
        console.error('Error fetching photos:', error);
      } finally {
        // setLoading(false);
      }
    };

    fetchPhotos();
  }, [cardId]);

  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center p-8">
  //       <div className="flex items-center space-x-2 text-gray-600">
  //         <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  //           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
  //           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  //         </svg>
  //         <span>Loading gallery...</span>
  //       </div>
  //     </div>
  //   );
  // }

  // if (photos.length === 0) {
  //   return null;
  // }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: -50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
      className={`py-10 ${fontP} text-center`}
    >
      <style>
        {`
          .swiper-pagination-bullet {
            background-color: #d53f8c;
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }

          .swiper-pagination-bullet-active {
            background-color: #f87171;
          }
        `}
      </style>
      <div>
        {photos.length === 0 ? (
          null
        ):(
          <div>
            <h2 className="text-lg uppercase mb-4">Gallery</h2>
            <div className="md:w-2/5 w-4/5 mx-auto overflow-hidden">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={1}
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                className="swiper-container"
              >
                {photos.map((photo, index) => (
                  <SwiperSlide key={photo.id || index}>
                    <div className="py-8">
                      <div className="relative w-full aspect-[1/1]">
                        <img 
                          src={photo.image_url} 
                          alt={photo.title}
                          className="w-full h-full object-cover rounded-lg"
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        )}
        
      </div>
    </motion.div>
  );
};

export default PhotoSlider;
